import {useSearchParams} from 'react-router-dom';
import {useCallback, useMemo, useState} from 'react';
import {RESET_PASSWORD_MODAL_CONTENT} from '../components/ResetPasswordModalContent';
import {resetPassword} from '../api/resetPassword';

export enum MESSAGE_TYPE {
  SUCCESS = 'success',
  ERROR = 'error'
}

export const useResetPassword = ({ newPassword }) => {
  const [message, setMessage] = useState<string>('');
  const [messageType, setMessageType] = useState<MESSAGE_TYPE>(MESSAGE_TYPE.ERROR);
  const [dialogContent, setDialogContent] = useState<RESET_PASSWORD_MODAL_CONTENT | ''>('');

  const [searchParams] = useSearchParams();

  const oobCode = useMemo(() => searchParams.get('oobCode') || '', [searchParams]);

  const submit = useCallback(async () => {
    setDialogContent(RESET_PASSWORD_MODAL_CONTENT.LOADING);

    if (!oobCode) {
      setDialogContent(RESET_PASSWORD_MODAL_CONTENT.MESSAGE);
      setMessage('無效的重設連結，請重新請求密碼重設！');
      setMessageType(MESSAGE_TYPE.ERROR);
      return;
    }

    try {
      await resetPassword({ oobCode, newPassword })
      setDialogContent(RESET_PASSWORD_MODAL_CONTENT.MESSAGE);
      setMessage('密碼已成功重設，請重新登入！');
      setMessageType(MESSAGE_TYPE.SUCCESS);
    } catch (error) {
      if (error.message === 'Firebase: Error (auth/invalid-action-code).') {
        setMessage('連結已失效，請重新請求密碼重設信！');
      } else {
        setMessage('重設失敗，請稍後再試！');
      }
      setDialogContent(RESET_PASSWORD_MODAL_CONTENT.MESSAGE);
      setMessageType(MESSAGE_TYPE.ERROR);
    }
  }, [oobCode, newPassword])

  const confirmCompleted = () => setDialogContent('')

  return { message, messageType, dialogContent, submit, confirmCompleted }
}